module.exports = __webpack_public_path__ + "components/breakheader/background/background--5-fafcb22765554db720b428b0280426ce.jpg";